import axios from 'axios';

class IAAgentsAPI {
  constructor() {
    // URL base específica para a API de IA Agents
    this.baseUrl = 'https://agents.scheduler.jera.com.br/api';
  }

  // Método auxiliar para construir URLs
  buildUrl(path = '') { 
    return `${this.baseUrl}${path}`;
  }

  // Criar Clínica (create_clinic)
  createClinic(clinicData) {
    return axios.post(this.buildUrl('/clinics'), clinicData);
  }

  // Update Clínica (update_clinic)
  updateClinic(accountId, clinicData) {
    return axios.put(this.buildUrl(`/clinics/${accountId}`), clinicData);
  }

  // Obter Clínica por Account ID (get_clinic_by_account_id)
  getClinicByAccountId(accountId) {
    return axios.get(this.buildUrl(`/clinics/${accountId}`));
  }

  // Criar Assistente (create_assistant)
  createAssistant(accountId, assistantData) {
    return axios.post(this.buildUrl(`/clinics/${accountId}/assistants`), assistantData);
  }

  // update Assistente (update_assistant)
  updateAssistant(accountId, assistantId, assistantData) {
    return axios.put(this.buildUrl(`/clinics/${accountId}/assistants/${assistantId}`), assistantData);
  }

  // Upload de Fonte de Conhecimento (upload_knowledge_source)
  uploadKnowledgeSource(accountId, formData) {
    return axios.post(
      this.buildUrl(`/clinics/${accountId}/knowledge_sources`), 
      formData, 
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  }

  // Delete Fonte de Conhecimento (delete_knowledge_source)
  deleteKnowledgeSource(accountId, knowledgeSourceId) {
    return axios.delete(this.buildUrl(`/clinics/${accountId}/knowledge_sources/${knowledgeSourceId}`));
  }
}

export { IAAgentsAPI }; 